import { Link } from "react-router-dom";
import StepCounter from "../Common/StepCounter";
import StarRatingStepper from "../Common/StarRatingStepper";
import { useState, useEffect } from 'react';
import {useParams } from 'react-router-dom';
import axios from "axios";
import Swal from 'sweetalert2'
import RowRadioButtonsGroup from "../Common/RowRadioButtonsGroup";


export default function AssessmentSample() {
    let { usrData } = useParams();
    const [questions, setQuestions] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [params, setParams] = useState([]);
    const [currentQuestion, setCurrentQuestion] = useState();
    const [currentIndex, setCurrentIndex] = useState(0);  
    const [value, setValue] = useState('');
    const [error, setError] = useState('');
    const [assessmentStatus, setAssessmentStatus] = useState('0');
    const [assessmentConfig, setAssessmentConfig] = useState(null);
    const [isLoading, setIsLoading] = useState(true)    

    useEffect(()=>{
        if(usrData){
            getAssessmentDetails()
        }
    },[usrData])

    const getAssessmentDetails = async() => {
        await axios.get(`/api/getSurveyDetails?surveyData=${usrData}`)
        .then(async function (response) {
            let result = response.data;
            if(result.success){
                console.log("result=>",result);
                
                setQuestions(result.data.questions)
                setParams(result.data.params)
                setAssessmentConfig(result.data.assessment);
                setIsLoading(false)
            }
        })
    }

    useEffect(()=>{
        setCurrentQuestion(questions[currentIndex])
        if(answers && answers[currentIndex]){            
            setValue(answers[currentIndex])  
        }
    },[currentIndex, questions, answers])

    const handleBack = () => {
        setError('')
        setCurrentIndex(currentIndex >= 1 ? currentIndex-1: currentIndex)
    }

    const handleNext = async( isSubmit = '') => {
        answers[currentIndex] = value
        setError('')
        setCurrentIndex(currentIndex+1)
        
        setValue('');
        if(isSubmit === '1'){
            setAssessmentStatus('1')
        }
    }

    const getRatingOptions = () => {
    if (!assessmentConfig) return [];

    const scalePoint = Number(assessmentConfig.scalePoint);
    const measurementType = assessmentConfig.measurementType;

    const optionsMap = {
            5: {
                Frequency:["Not Observed","Never","Rarely","Sometimes","Often","Always"],
                Quality: ["Not Observed","Poor","Fair","Good","Very Good","Excellent"],
                Agreement: ["Not Observed","Strongly Disagree","Disagree","Neutral","Agree","Strongly Agree"],
                Proficiency: ["Not Observed","Novice","Beginner","Competent","Proficient","Expert"],
                Demonstration: ["Not Observed","Not Demonstrated","Partially Demonstrated","Adequately Demonstrated","Fully Demonstrated","Exceptionally Demonstrated"]
            },
            7: {
                Frequency: ["Not Observed","Never","Rarely","Occasionally","Sometimes","Frequently","Often","Always"],
                Quality: ["Not Observed","Unsatisfactory","Needs Improvement","Adequate","Developing Strength","Effective","Highly Effective","Exceptional"],
                Agreement:["Not Observed","Strongly Disagree","Disagree","Somewhat Disagree","Neutral","Somewhat Agree","Agree","Strongly Agree"],
                Proficiency: ["Not Observed","Novice","Beginner","Developing","Competent","Proficient","Advanced","Expert"],
                Demonstration: ["Not Observed","Not Demonstrated","Slightly Demonstrated","Partially Demonstrated","Adequately Demonstrated","Substantially Demonstrated","Fully Demonstrated","Exceptionally Demonstrated"]
            }
        };
        console.log("scalePoint:", scalePoint);
        console.log("measurementType:", measurementType);

        return optionsMap[scalePoint]?.[measurementType] || [];
    };


    const closeTab = () => {
        // alert('Please close this tab manually.');
        window.open("https://www.google.com", "_self");
    }

    const checkKeyDown = (e) => {
        if (e.key === 'Enter') e.preventDefault();
    };

    return(       
       <div className="RgCenterAlign">
            {
                isLoading ? 
                <div className="loader-center">
                    <div className="spinner-border text-white" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
                :
                <div className="card survey-card">
                    <div className="card-header border-0 text-center">
                        <Link to='/'>
                            <img src={process.env.REACT_APP_BASE_URL+"assets/img/first-feedback-logo.png"} className="logo img-fluid" alt="logo" />
                        </Link>
                        {assessmentStatus === '1' ? '' : <h4 className="text-center">Question {currentIndex+1}/{questions.length}</h4>}                        
                    </div>
                    {assessmentStatus === '1' ? 
                        <div className="card-body">
                            <div className="submitCheck">
                                <img src={process.env.REACT_APP_BASE_URL+"assets/img/circle-check.gif"}/>
                                <br></br><br></br>
                                <h4>Thank you..<br></br>Your survey has been successfully submitted.</h4>
                                <button className="btn btn-primary" onClick={closeTab}>Finish and Close</button>
                            </div>
                        </div> 
                    :
                    <div className="card-body">                        
                        <hr/>
                        <form method="POST" onKeyDown={(e) => checkKeyDown(e)}>
                            { currentQuestion ?
                                    (currentQuestion.question.questionTypeId === 1 ? 
                                        <div className="row mb-5">                                            
                                            <div className="col-md-12">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h5 className="fw-semibold ">{currentQuestion && currentQuestion.question.name}</h5>
                                                    {/* <h4>{currentIndex+1}/{questions.length}</h4> */}
                                                </div>
                                                {/* <h5>{currentQuestion.question.name}</h5> */}
                                                <div className="RgRating">
                                                    <RowRadioButtonsGroup value={value} setValue={setValue} setError={setError} handleNext={handleNext} currentIndex={currentIndex} totalQuestions={questions.length} options={getRatingOptions()} params={params} is_sample={true}/>                                                   
                                                    {/* <StarRatingStepper value={value} setValue={setValue} handleNext={handleNext}/>      */}
                                                </div>                                                  
                                            </div>
                                        </div>
                                    :
                                    <div className="row mb-5">
                                        <div className="col-md-12">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <h5 className="fw-semibold ">{currentQuestion && currentQuestion.question.name}</h5>
                                                {/* <h4>{currentIndex+1}/{questions.length}</h4> */}
                                            </div>
                                            {/* <h5>{currentQuestion.question.name}</h5> */}
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Enter your response" 
                                                onChange={(e) => {
                                                    setValue(e.target.value);
                                                    setError('')
                                                }} 
                                                value={value}
                                            />                                                  
                                        </div>
                                    </div>)                                
                                :''
                            }  
                            <span className="text-danger">{error?error:''}</span>                           
                            <hr/>
                            <div className={currentIndex < questions.length-1 ? "d-flex justify-content-between align-items-center" : ""}>
                                {/* {
                                    currentIndex < questions.length-1 ?
                                    <div className="text-warning">Once you have selected an option you will automatically move to the next question</div>
                                    : ''
                                } */}
                                <div></div>
                                <div className="d-flex justify-content-end">
                                    {
                                        currentIndex > 0 ?
                                            <button type="button" className="btn btn-outline-secondary me-4" onClick={handleBack}><span className="bi bi-chevron-left"></span>&nbsp; Back </button>
                                        :"" 
                                    }

                                    { 
                                    currentIndex < questions.length-1 ?
                                        <button type="button" className="btn btn-primary" onClick={() =>{ handleNext('')} }> Next &nbsp; <span className="bi bi-chevron-right"></span></button>
                                    :
                                        (currentIndex === questions.length-1 ? <button type="button" className="btn btn-primary"  onClick={() => {handleNext('1')}}> Save & Submit</button> : "")
                                    }
                                </div>
                            </div>                            
                        </form>
                    </div> 
                   }                                    
                </div>
            }                
        </div>
    )
}